export const constants = {
    maxLoadingDelay: 10000
};
